import api from "@/services/api"
import { ref } from "vue"
import { useNotification } from "@/composables"

export const useLocalties = () => {
    const { showError } = useNotification()

    const apiLocalties = ref([])
    const setApiLocalties = (value) => {
        apiLocalties.value = value
    }

    const fetchingLocalties = ref(false)
    const setFetchingLocalties = (value) => {
        fetchingLocalties.value = value
    }

    const fetchLocalties = async (stateId) => {
        try {
            setFetchingLocalties(true)
            const response = await api.get(`/states/${stateId}/localties`)
            setApiLocalties(response.data.data)
        } catch (error) {
            console.error(error)
            showError("Failed to fetch localties")
        } finally {
            setFetchingLocalties(false)
        }
    }

    return {
        apiLocalties,
        fetchLocalties,
        fetchingLocalties
    }
}